import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import PublicIcon from '@mui/icons-material/Public';

const FooterHome = () => {
  const navigate = useNavigate();
  const RedirectToContactUs = () => navigate('/contactus');
  const RedirectToPrivacy = () => navigate('/privacypolicy');
  const RedirectToTerms = () => navigate('/termsofservice');
  const RedirectToMerchantTerms = () => navigate('/merchanttermsofservice');

  return (
    <div
      style={{
        backgroundColor: 'rgb(24, 20, 54)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 'auto', // ⭐ key line
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100px',
          px: 4,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#fff',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        <Typography color='gray'>©2026 SingleCombo - All rights reserved</Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Typography sx={{ cursor: 'pointer' }} onClick={RedirectToContactUs}>
            Contact Us
          </Typography>
          {/* <Typography sx={{ cursor: 'pointer' }} onClick={RedirectToTerms}>
            Terms & Conditions
          </Typography> */}
          <Typography sx={{ cursor: 'pointer' }} onClick={RedirectToPrivacy}>
            Privacy Policy
          </Typography>
          {/* <Typography sx={{ cursor: 'pointer' }} onClick={RedirectToPrivacy}>
            Cookie Policy
          </Typography> */}
          <Typography sx={{ cursor: 'pointer' }} onClick={RedirectToMerchantTerms}>
            Merchant Terms of Service
          </Typography>
        </Box>

        <Box>
          <IconButton>
            <FacebookIcon sx={{ color: '#fff' }} />
          </IconButton>
          <IconButton>
            <TwitterIcon sx={{ color: '#fff' }} />
          </IconButton>
          <IconButton>
            <InstagramIcon sx={{ color: '#fff' }} />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default FooterHome;
